import { CheckCircleIcon } from "@chakra-ui/icons";
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  openCreateStudent,
  openStudentReportModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  approveStudentRequest,
  getAllStudentsRequest,
  rejectStudentRequest,
} from "../../../modules/superadmin-modules/students/Actions";

const PendingStudentsTable = ({ setAdd, setSelectedData, searchTerm, tab }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.superadminstudents.isLoading);
  const count = useSelector((state) => state.superadminstudents.count);
  const students = useSelector((state) => state.superadminstudents.students);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  useEffect(() => {
    const timeId = setTimeout(() => {
      if (tab == 1)
        dispatch(
          getAllStudentsRequest({ page: pageNumber + 1, name: searchTerm })
        );
    }, 500);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab]);

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = students?.items?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: data?.phone,

      approve: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          // isLoading={selected.id == data?.id ? isRestrict : false}
          icon={<CheckCircleIcon color={"green"} />}
          onClick={() => {
            dispatch(
              approveStudentRequest({
                id: data?.id,
                action: () => dispatch(getAllStudentsRequest()),
              })
            );
          }}
        />
      ),
      reject: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          // isLoading={selected.id == data?.id ? isRestrict : false}
          icon={<IoClose color={"red"} />}
          onClick={() => {
            dispatch(
              rejectStudentRequest({
                id: data?.id,
                action: () => dispatch(getAllStudentsRequest()),
              })
            );
          }}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " #",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: " رقم الطالب",
      accessor: "phone",
    },
    {
      Header: "رقم المتابعة ",
      accessor: "father_phone",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "اسم المستخدم",
      accessor: "user_name",
    },

    {
      Header: "Major",
      accessor: "major.name_ar",
    },
    {
      Header: "Grade",
      accessor: "grade.name_ar",
    },
    {
      Header: "",
      accessor: "approve",
    },
    {
      Header: "",
      accessor: "reject",
    },
  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        >
          تعديل
        </MenuItem>
      </MenuList>
    </Menu>
  );
  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data || []}
      path={"openModel"}
      Actions={actions}
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(count / 50)}
    />
  );
};

export default PendingStudentsTable;
